export interface LocalLibraryDirectoryEntry {
  name: string;
  path: string;
  isDirectory: boolean;
  sizeBytes?: number;
  modifiedUnix?: number;
  albumCount?: number;
  trackCount?: number;
}

export interface LocalLibraryDirectoryListing {
  path: string;
  parent: string | null;
  entries: LocalLibraryDirectoryEntry[];
}

function parentPathForListing(path: string): string | null {
  if (!path) return null;
  const norm = path.replace(/\\/g, '/').replace(/\/+$/, '');
  const idx = norm.lastIndexOf('/');
  if (idx <= 0) return null;
  return norm.slice(0, idx) || '/';
}

export async function listLocalLibraryDirectory(
  path: string,
): Promise<LocalLibraryDirectoryListing> {
  const { connectorInvoke, listDirectory } = await import('./connector');
  try {
    return await connectorInvoke<LocalLibraryDirectoryListing>('local_library_list_directory', { path });
  } catch (e: unknown) {
    const msg = String((e as { message?: string })?.message ?? e ?? '');
    const useFilesystemFallback =
      /not allowed by ACL|unknown command|command .+ not found|database is locked/i.test(msg);
    if (!useFilesystemFallback) {
      throw e;
    }
    const entries = await listDirectory(path);
    return {
      path,
      parent: parentPathForListing(path),
      entries: (entries || []).map((ent) => ({
        name: ent.name,
        path: ent.path,
        isDirectory: ent.is_dir,
      })),
    };
  }
}
